// components/OfficerFormModal.js
import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const OfficerFormModal = ({ show, handleClose, handleSubmit, initialData }) => {
  const [formData, setFormData] = useState({
    full_name: "",
    nickname: "",
    whatsapp_number: "",
    email: "",
    address: "",
    position: "",
    division: "",
    start_date: "",
    birth_date: "",
    payroll_type: "bank",
    payroll_account: "",
    photo: null,
  });

  useEffect(() => {
    if (initialData) setFormData(initialData);
    else setFormData(prev => ({ ...prev, payroll_type: "bank" }));
  }, [initialData]);

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = () => handleSubmit(formData);

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{initialData ? "Edit Officer" : "Add Officer"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="row">
            <Form.Group className="col-md-6 mb-3">
              <Form.Label>Full Name</Form.Label>
              <Form.Control name="full_name" value={formData.full_name} onChange={onChange} />
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label>Nickname</Form.Label>
              <Form.Control name="nickname" value={formData.nickname} onChange={onChange} />
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="col-md-6 mb-3">
              <Form.Label>WA Number</Form.Label>
              <Form.Control name="whatsapp_number" value={formData.whatsapp_number} onChange={onChange} />
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control name="email" value={formData.email} onChange={onChange} />
            </Form.Group>
          </div>
          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Form.Control as="textarea" rows={2} name="address" value={formData.address} onChange={onChange} />
          </Form.Group>
          <div className="row">
            <Form.Group className="col-md-6 mb-3">
              <Form.Label>Position</Form.Label>
              <Form.Control name="position" value={formData.position} onChange={onChange} />
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label>Division</Form.Label>
              <Form.Control name="division" value={formData.division} onChange={onChange} />
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="col-md-6 mb-3">
              <Form.Label>Start Date</Form.Label>
              <Form.Control type="date" name="start_date" value={formData.start_date} onChange={onChange} />
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label>Birth Date</Form.Label>
              <Form.Control type="date" name="birth_date" value={formData.birth_date} onChange={onChange} />
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="col-md-6 mb-3">
              <Form.Label>Payroll Type</Form.Label>
              <Form.Select name="payroll_type" value={formData.payroll_type} onChange={onChange}>
                <option value="bank">Bank</option>
                <option value="e_wallet">E-Wallet</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label>Payroll Account</Form.Label>
              <Form.Control name="payroll_account" value={formData.payroll_account} onChange={onChange} />
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="col-md-6 mb-3">
              <Form.Label>Profile Photo</Form.Label>
              <Form.Control type="file" name="photo" onChange={(e) => {
                const file = e.target.files[0];
                console.log(file); // Add this line for debugging
                const updatedFormData = { ...formData, photo: file };
                setFormData(updatedFormData);
                console.log(updatedFormData);
              }} />
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Cancel</Button>
        <Button variant="primary" onClick={onSubmit}>
          {initialData ? "Update" : "Add"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OfficerFormModal;
